import PropTypes from 'prop-types'
import React, { Component, createElement } from 'react'

import { Option as NoteOption } from './NoteInput'

import styles from './style.styl'

const style = {
  width: 120,
  height: 37.5
}

const ActionToComponent = {
  note : NoteOption
}

class Inputs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedAction: 'note'
    }
  }

  makeOnActionSelect = (key) => {
    return () => {
      this.setState({ selectedAction: key })
    }
  }

  renderActions() {
    return _.map(ActionToComponent, (value, key) => {
      const selected = key === this.state.selectedAction
      return (
        <div
          style={style}
          className={`${ selected ? styles.SelectedAction : styles.Action} flex-center`}
          onClick={this.makeOnActionSelect(key)}
          key={key}
        >
          {value.display}
        </div>
      )
    })
  }

  render() {
    const selectedComponent = ActionToComponent[this.state.selectedAction].component
    return (
      <div style={{ padding: '0 1rem' }}>
        <div className="flex">
          {this.renderActions()}
        </div>
        {createElement(selectedComponent, { endUser: this.props.endUser })}
      </div>
    )
  }
}

export default Inputs



// WEBPACK FOOTER //
// ./src/scripts/components/customer/Inputs/index.js